import { useState } from 'react';
import { cn, IconButton, Tooltip, useTranslate } from '@prenuvo/halo';
import { Phone } from '@prenuvo/halo-icon';

import { useAddendum } from '@/core/addendum';

import { usePatientPermissionsAndDetails } from '../use-header-permissions.hook';
import { PatientContactDialog } from './patient-contact-dialog';

export function PatientContact() {
  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);
  const { isFieldEditable } = useAddendum();

  const isEditable = isFieldEditable('patientContact');

  const translate = useTranslate();
  const { patientDisplayName } = usePatientPermissionsAndDetails();

  const handleContactDialogClose = (value: boolean) => {
    setIsContactDialogOpen(!value);
  };

  const label = translate('FCT.REPORTING.HEADER.CONTACT_DETAILS.LABEL.ICON');

  return (
    <span className="flex items-center py-1 pr-1" data-testid="patient-name">
      <span className="mr-1">{patientDisplayName}</span>

      <Tooltip className={cn({ hidden: !isEditable })} content={label} side="bottom">
        <IconButton
          aria-label={label}
          data-testid="patient-contact-details-button"
          disabled={!isEditable}
          icon={Phone}
          onClick={() => setIsContactDialogOpen(true)}
          size="xs"
          variant="text"
        />
      </Tooltip>
      <PatientContactDialog closeDialog={handleContactDialogClose} open={isContactDialogOpen} />
    </span>
  );
}
